export const siteCart = {
  title: 'Your Cart',
  emptyState: {
    label: 'Your cart is empty.',
    subtitle: 'Add some products and get ready to take ownership of your health!',
    buttonLabel: 'Shop Products'
  },
  progressBar: {
    pricePrefix: 'You are ',
    priceSuffix: ' away from FREE shipping!',
    buttonLabel: 'Shop Products',
    reachedLabel: 'FREE shipping unlocked!'
  },
  subscriptionTitle: 'Subscription Purchases',
  oneTimeTitle: 'One time Purchases',
  freeGiftsTitle: 'Free Gifts',
  subscribeAndSaveBundle: 'Subscribe & save {{amount}}',
  subscriptionSavings: 'Save when you subscribe',
  omegaSubscriptionSavings: 'You saved {{amount}} subscribing for AG Omega3',
  omegaBundleSavings: 'You saved {{amount}} bundling AG Omega3 with AG1',
  agzSubscriptionSavings: 'You saved {{amount}} subscribing for AGZ',
  agzBundleSavings: 'You saved {{amount}} bundling AGZ with AG1',
  bundleToggleSuffix: 'Products',
  free: 'Free',
  clearCartText: 'Clear All',
  upsellTitle: 'You may also like',
  subtotalLabel: 'Subtotal',
  checkoutLabel: 'Checkout'
};
